import sortQueriesByKey from '../queryString/sortQueriesByKey';

export default function getStoreGuideId(guideId, attributes) {
  const sortedQueryString = sortQueriesByKey(attributes);

  return attributes ? encodeURIComponent(`${guideId}_${sortedQueryString}`) : guideId;
}
